export async function login(email, senha) {

    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (email === "admin" && senha === "admin") {
                localStorage.setItem(
                    "cise:user",
                    JSON.stringify({ email, role: "admin" })
                );
                resolve(true);
            } else {
                reject(new Error("Credenciais inválidas"));
            }
        }, 600);
    });
}

export function logout() {
    localStorage.removeItem("cise:user");
}

export function getCurrentUser() {
    const user = localStorage.getItem("cise:user");
    return user ? JSON.parse(user) : null;
}

export function isAuthenticated() {
    return !!getCurrentUser();
}